import React from 'react';
import { Alert, Box, Button } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { useImpersonationCtx } from '../../context/ImpersonationContext';
import { getUserName } from '../../utils/user.util';
import { useCurrUserCtx } from '../../context/CurrUserContext';

function ImpersonationBanner() {
  const { isImpersonating, impersonatingUser, stopImpersonating } = useImpersonationCtx();
  const { currUser } = useCurrUserCtx();

  if (!isImpersonating || !impersonatingUser) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1300,
        width: '100%',
      }}
    >
      <Alert
        severity="warning"
        icon={<PersonIcon />}
        action={
          <Button color="inherit" size="small" onClick={stopImpersonating}>
            Stop Impersonating
          </Button>
        }
        sx={{
          borderRadius: 0,
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        }}
      >
        <strong>Impersonating:</strong> You are viewing the application as{' '}
        <strong>{getUserName(impersonatingUser)}</strong> ({impersonatingUser.email}). All actions will be recorded
        under your account ({currUser?.email}).
      </Alert>
    </Box>
  );
}

export default ImpersonationBanner;
